import { handleActions } from "redux-actions";
import { getConverterConfigDone } from "../actions/actions";

export default handleActions(
  {
    [getConverterConfigDone]: (state, action) => {
      return action.payload;
    }
  },
  {}
);
